module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gI5Vc"))).then(() => parcelRequire('8rm4T'));